<!--
  Generated template for the TeamPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header>

    <ion-toolbar>
        <ion-title>Kontakt-Gruppen</ion-title>

        <ion-buttons slot="start">
            <ion-button (click)="dismiss()" color="primary">
                {{ 'CLOSE_BUTTON' | translate }}
            </ion-button>
        </ion-buttons>

        <ion-buttons slot="end">
            <ion-button (click)="saveData()" color="primary">
                {{ 'SAVE_BUTTON' | translate }}
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

</ion-header>


<ion-content class="ion-padding">

    <ion-item>  
        <ion-button (click)="createGroup()" class="">
            <ion-icon name="add"></ion-icon>
            &nbsp;Neue Gruppe
        </ion-button>
    </ion-item>
   


    <ion-card *ngFor="let contact of contactData">
        <ion-card-header>

            <div style="display: flex; justify-content: space-between;">
                <h1>{{contact.group}}</h1>
                <ion-button size="small" (click)="takeOver(contact)">
                    <ion-icon slot="icon-only" name="enter-outline"></ion-icon>
                </ion-button>
                <ion-button size="small" color="danger" (click)="trash(contact)">
                    <ion-icon slot="icon-only" name="trash"></ion-icon>
                </ion-button>
            </div>

        </ion-card-header>
        <ion-card-content>
            <app-phone-data (outContractData)="updateContactNumbers($event)" (selectedRow)="setPhoneContact($event)"
                        [addressData]="contact"
                        [isEdit]="true" [phoneData]="contact.contacts"></app-phone-data>
        </ion-card-content>
    </ion-card>

    <ion-button (click)="saveData()" expand="block" lage>Speichern</ion-button>
</ion-content>
